import './Home.css'
import companyImg from '../assets/images/company_img.png'
import icWord from '../assets/images/ic_word.png'
import icListen from '../assets/images/ic_listen.png'
import icWriting from '../assets/images/ic_writting.png'
import icAddress from '../assets/images/ic_address.webp'
import icPhone from '../assets/images/ic_phone.webp'
import icEmail from '../assets/images/ic_email.webp'

export default function Home() {
  return (
    <div className="home-container">
      {/* 导航栏 */}
      <nav className="navbar">
        <div className="logo">济南拾心科技有限公司</div>
        <div className="nav-menu">
          <a href="#header">首页</a>
          <a href="#about">关于我们</a>
          <a href="#connect">联系我们</a>
        </div>
      </nav>

      {/* 首页横幅 */}
      <header className="hero-section" id='header'>
        <div className="hero-content">
          <div className="hero-text">
            <h1>乐学英语四六级</h1>
            <p>专注于帮助大学生备考英语四六级的智能学习平台</p>
            <a href="https://sj.qq.com/appdetail/com.shixin.leenglish" className="start-btn">立即开始学习</a>
          </div>
          <div className="hero-image">
            
          </div>
        </div>
      </header>

      {/* 核心功能特点 */}
      <section className="features-section">
        <h2 className="section-title">核心功能特点</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <img src={icWord} alt="词汇学习" />
            </div>
            <h3>智能词汇学习</h3>
            <p>基于人工智能算法，为每位学员定制个性化的词汇学习计划，提高记忆效率。</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <img src={icListen} alt="听力训练" />
            </div>
            <h3>听力强化训练</h3>
            <p>提供丰富的听力练习材料，配合专业音频解析，帮助学员提升听力理解能力。</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <img src={icWriting} alt="写作批改" />
            </div>
            <h3>写作批改系统</h3>
            <p>采用 AI 智能批改技术，实时评估作文水平，提供专业的修改建议。</p>
          </div>
        </div>
      </section>
{/* 关于我们 */}
      <section className="about-section" id='about'>
        <h2 className="section-title">关于我们</h2>
        <div className="about-container">
          <div className="about-image">
            <img src={companyImg} alt="公司简介" />
          </div>
          <div className="about-content">
            <p>济南拾心科技有限公司成立于 2020 年，是一家专注于教育科技创新的企业。我们致力于提供先进的技术应用于教育领域，为学习者提供更高效、更智能的学习解决方案。</p>
            <p>公司拥有一支优秀创新精神的研发团队，在人工智能、教育心理学等领域有着深厚的技术积累。我们始终坚持以用户为中心，不断优化产品体验，为广大学子的英语学习之路保驾护航。</p>
          </div>
        </div>
      </section>

      {/* 联系我们 */}
      <section className="contact-section" id='connect'>
        <h2 className="section-title">联系我们</h2>
        <div className="contact-grid">
          <div className="contact-item">
            <div className="contact-icon">
              <img src={icAddress} alt="地址" />
            </div>
            <h3>公司地址</h3>
            <p>山东省济南市</p>
          </div>
          <div className="contact-item">
            <div className="contact-icon">
              <img src={icPhone} alt="电话" />
            </div>
            <h3>联系电话</h3>
            <p>18366835127</p>
          </div>
          <div className="contact-item">
            <div className="contact-icon">
              <img src={icEmail} alt="邮箱" />
            </div>
            <h3>电子邮箱</h3>
            <p>syzblue@163.com</p>
          </div>
        </div>
      </section>

      {/* 页脚 */}
      <footer className="footer">
        <div className="footer-content">
          <p>© 2024 济南拾心软件科技有限公司 版权所有</p>
          <p>备案号: <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2024128407号-1</a></p>
        </div>
      </footer>
    </div>
  )
}